// Última empresa aberta neste navegador (para o /app voltar nela quando há mais de uma).
const KEY = 'impulso:ultima-empresa'

export function getLastCompany(): string | null {
  try { return localStorage.getItem(KEY) } catch { return null }
}

export function setLastCompany(id: string) {
  try { localStorage.setItem(KEY, id) } catch { /* armazenamento bloqueado: segue sem lembrar */ }
}
